export default "__VITE_ASSET__CR60GVbe__"